import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel"
}

import { onBeforeMount, ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useMe } from '@/modules/user/Me';
import { handleLoadError } from '@/core/common';
import PageLayout from '@/core/components/PageLayout.vue';
import CustomerTicketFormInfo from '@/modules/customer/components/CustomerTicketFormInfo.vue';
import { MeCustomer } from '@/modules/customer/Customer';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerTicketFormInfoPage',
  setup(__props) {

const { $gettext } = useGettext();
const meResource = useMe();
const customer = ref<MeCustomer | null>(null);

onBeforeMount(async () => {
	try {
		customer.value = await meResource.getCustomer();
	} catch (e) {
		handleLoadError(e as Error, 'dashboard');
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Rapportformulär')
  }, {
    default: _withCtx(() => [
      (customer.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(CustomerTicketFormInfo, { customer: customer.value }, null, 8, ["customer"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})